<script lang="ts">
  import type { AfterState } from '@pin/schemas/client-state-response';
  import { onMount } from 'svelte';
  import CouldNotVote from '../components/CouldNotVote.svelte';
  import FurtherNavigation from '../components/FurtherNavigation.svelte';
  import voteStore from '../stores/voteStore';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  export let pollData: AfterState;

  onMount(() => {
    trackEvent(
      { action: 'state:after-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

<!-- svelte-ignore a11y-autofocus -->
<div class="wrapper">
  <h2 autofocus tabindex="-1">{i18n('poll.after')}</h2>
  {#if $voteStore != null}
    <p>{i18n('poll.after-thanks')}</p>
  {:else}
    <p class="could-not-vote-text">
      Direktesendingen er over og avstemningen er derfor stengt.
    </p>
    <CouldNotVote endTime={pollData.endTime} />
  {/if}
  <div class="link-wrapper">
    <a href="https://www.nrk.no/mgp" target="_blank">
      Gjenopplev høydepunktene fra MGP på <span>NRK.no/mgp</span>
    </a>
  </div>

  <h2 class="further-navigation-header">Oppdag mer</h2>
  <FurtherNavigation big={true} />
</div>

<style>
  .wrapper {
    margin: 1rem 0 2rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .link-wrapper {
    margin-top: 1rem;
  }

  .could-not-vote-text {
    margin: 1rem 0;
  }
  span {
    color: var(--mgp-cream);
  }

  .further-navigation-header {
    margin: 2rem 0 1rem 0;
  }
</style>
